import Data from "./Data.js";
import Renders from "./Renders.js";

export default class LoadMoreActions
{
    constructor() {
        this.data = new Data();
    }

    transactions(button, offset, limit) {
        if (button.classList.contains('button--disabled')) {
            return;
        }

        const payload = {offset, limit, ...button.dataset};
        this.data.transactions(payload).then(results => {
            if (results.status === 'success' && !results.error) {
                offset = parseInt(offset);
                limit = parseInt(limit);

                const items = Object.keys(results.data).length;
                button.dataset.offset = offset + items;

                if (items < limit) {
                    button.classList.add('button--disabled');
                } else {
                    button.classList.remove('button--disabled');
                }

                if (items) {
                    const grid = document.querySelector('.grid__content');
                    const template = document.getElementById('transactions-list-template').content;
                    const row = template.querySelector('.grid__row');

                    const render = new Renders();

                    for (let txId in results.data) {
                        grid.appendChild(render.transaction(results.data[txId], row.cloneNode(true)));
                    }
                }
            }
        });
    }

    transactionTemplates(button, offset, limit) {
        if (button.classList.contains('button--disabled')) {
            return;
        }

        const payload = {offset, limit, ...button.dataset};

        this.data.transactionTemplates(payload).then(results => {
            if (results.status === 'success' && !results.error) {
                offset = parseInt(offset);
                limit = parseInt(limit);

                const items = Object.keys(results.data).length;
                button.dataset.offset = offset + items;

                if (items < limit) {
                    button.classList.add('button--disabled');
                } else {
                    button.classList.remove('button--disabled');
                }

                if (items) {
                    const grid = document.querySelector('.grid__content');
                    const template = document.getElementById('tx-tmp-list-template').content;
                    const row = template.querySelector('.grid__row');

                    const render = new Renders();

                    for (let txId in results.data) {
                        grid.appendChild(render.transactionTemplate(results.data[txId], row.cloneNode(true)));
                    }
                }
            }
        });
    }

    notes(button, offset, limit) {
        this.data.notes({offset, limit}).then(results => {
            if (results.status === 'success' && !results.error) {
                offset = parseInt(offset);
                limit = parseInt(limit);

                const items = Object.keys(results.data).length;
                button.dataset.offset = offset + items;

                if (items < limit) {
                    button.remove();
                }

                if (items) {
                    const container = document.querySelector('.notes-container');
                    const template = container.querySelector('.placeholder:first-child');
                    const render = new Renders();

                    for (let id in results.data) {
                        container.appendChild(render.note(results.data[id], template.cloneNode(true)));
                    }
                }
            }
        });
    }
}